import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'categoryFilter',
    standalone: true
})
export class CategoryFilterPipe implements PipeTransform {

    transform(categories: any, brandId: number): any {
        if (!categories || (brandId !== 19)) {  // filter only for eatClub
            return categories;
        }

        return categories.filter(category => !category.is_subscribable);
    }

}
